import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const FicheClientEntreprise = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="u-p-4-mind-fiche-client-entreprise-qx7z6xk"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default FicheClientEntreprise;